/**
 * useHasLabelNegotiations — does the caller's TENANT own any draft label?
 *
 * Single source of truth for greying out the three "Label Negotiations"
 * controls, all of which can only return nothing for a tenant with no drafts:
 *
 *   1. Cogni's ``draft_review`` pill        — labelled "Label Negotiations"
 *   2. Investigator's ``label_negotiations`` pill — same visible label
 *   3. Cogni's "Include draft label negotiations" checkbox (labels mode)
 *
 * (1) and (2) are two DIFFERENT searchModes rendering the same label — see
 * ``labelFor`` in SearchFilters. Both must be gated; gating one is a half fix.
 *
 * Mirrors ``useIsAdmin``: delegates to ``useDbUser()``, which reads the flag
 * off ``POST /auth/sync``. The backend computes it as an org-scoped EXISTS on
 * ``label_versions`` (``_org_has_label_negotiations`` in auth_routes.py) — the
 * same org scoping ``/versions/drafts`` applies, and fail-closed for a user
 * with no org.
 *
 * Returns ``false`` until ``/auth/sync`` resolves, so the controls render
 * greyed for a beat and then enable — the same "default to the safer path"
 * behaviour ``useIsAdmin`` documents. Callers needing to distinguish "still
 * loading" from "confirmed no drafts" should use ``useDbUser()`` directly.
 *
 * This is a UX gate, not a security boundary: draft data is already isolated
 * per tenant by RLS, so bypassing this gets you an empty result set, not
 * another tenant's drafts.
 */
import { useDbUser } from './useDbUser';

export function useHasLabelNegotiations(): boolean {
  const { hasLabelNegotiations } = useDbUser();
  return hasLabelNegotiations;
}
